var _circle, _path, _defs;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgComparisonIconCheck(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 26 26",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 13,
    cy: 13,
    r: 13,
    fill: "url(#Comparison_Icon_-_Check_svg__paint0_linear_7134_20280)"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M18.571 9.797l-7.15 7.15-3.25-3.25",
    stroke: "#fff",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "Comparison_Icon_-_Check_svg__paint0_linear_7134_20280",
    x1: -2.5,
    y1: 3.5,
    x2: 12.544,
    y2: 27.501,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F7BEAC"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.335,
    stopColor: "#ED7F5B"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.555,
    stopColor: "#E76C44"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#E2A591"
  })))));
}

export default SvgComparisonIconCheck;